import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getRestaurants = createAsyncThunk(
  "Restaurant/getRestaurants",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/restaurant/settings`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: data && data,
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateRestaurants = createAsyncThunk(
  "Restaurant/updateRestaurants",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/settings`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              lang: Cookies.get("zado_lng"),
              Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getBranches = createAsyncThunk(
  "Restaurant/getBranches",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/restaurant/branches`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: data && data,
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getBranchesID = createAsyncThunk(
  "Restaurant/getBranchesID",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/branches/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              lang: Cookies.get("zado_lng"),
              Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const addBranches = createAsyncThunk(
  "Restaurant/addBranches",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/branches`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const updateBranches = createAsyncThunk(
  "Restaurant/updateBranches",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/branches/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const deleteBranches = createAsyncThunk(
  "Restaurant/deleteBranches",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/branches/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getNoftfications = createAsyncThunk(
  "Restaurant/getNoftfications",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/notifications`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              lang: Cookies.get("zado_lng"),
              Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
            },
            params: {
              only_not_read: 1,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
// updateNotifications
export const updateNotifications = createAsyncThunk(
  "Restaurant/updateNotifications",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/notifications/${id}/mark-as-read`,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              lang: Cookies.get("zado_lng"),
              Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getDrivers = createAsyncThunk(
  "Drivers/getDrivers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/drivers`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getResturantContracts = createAsyncThunk(
  "Drivers/getResturantContracts",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/contracts`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: { is_restaurant: 1 },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getResturantContractsById = createAsyncThunk(
  "Drivers/getResturantContractsById",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/contracts/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: { is_restaurant: 1 },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateResturantContracts = createAsyncThunk(
  "Restaurant/updateResturantContracts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/contracts/${data.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              lang: Cookies.get("zado_lng"),
              Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
const RestaurantsSlice = createSlice({
  name: "Restaurant",
  initialState: {
    isRestaurantLoading: false,
    error: null,
    RestaurantArr: null,
    RestaurantIDArr: null,
    BranchesArray: null,
    BrancheIDArray: null,
    NotificationsArr: null,
    getDriversArray: null,
    ResturantContractsArray: null,
    ResturantContractsByIDArray: null,
  },
  reducers: {
    SetNoftficationsPusher: (state, action) => {
      if (!state.NotificationsArr) {
        state.NotificationsArr = []; // تأكد من أنها ليست null
      }

      state.NotificationsArr.unshift(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDrivers.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getDrivers.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.getDriversArray = action.payload.data;
      })
      .addCase(getDrivers.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(getNoftfications.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getNoftfications.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.NotificationsArr = action.payload.data.data;
      })
      .addCase(getNoftfications.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(updateNotifications.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(updateNotifications.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(updateNotifications.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(getRestaurants.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getRestaurants.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.RestaurantArr = action.payload.data;
      })
      .addCase(getRestaurants.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(updateRestaurants.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(updateRestaurants.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(updateRestaurants.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // getBranches
      .addCase(getBranches.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getBranches.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.BranchesArray = action.payload.data;
      })
      .addCase(getBranches.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // getBranchesID
      .addCase(getBranchesID.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getBranchesID.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.BrancheIDArray = action.payload.data;
      })
      .addCase(getBranchesID.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // addBranches
      .addCase(addBranches.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(addBranches.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(addBranches.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // updateBranches
      .addCase(updateBranches.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(updateBranches.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(updateBranches.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // deleteBranches
      .addCase(deleteBranches.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(deleteBranches.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;

        state.BranchesArray = state.BranchesArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteBranches.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // ResturantContracts
      .addCase(getResturantContracts.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getResturantContracts.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.ResturantContractsArray = action.payload.data;
      })
      .addCase(getResturantContracts.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // getResturantContractsById
      .addCase(getResturantContractsById.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(getResturantContractsById.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
        state.ResturantContractsByIDArray = action.payload.data;
      })
      .addCase(getResturantContractsById.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      })
      // updateResturantContracts
      .addCase(updateResturantContracts.pending, (state) => {
        state.isRestaurantLoading = true;
      })
      .addCase(updateResturantContracts.fulfilled, (state, action) => {
        state.isRestaurantLoading = false;
      })
      .addCase(updateResturantContracts.rejected, (state, action) => {
        state.isRestaurantLoading = false;
      });
  },
});
export const { SetNoftficationsPusher } = RestaurantsSlice.actions;

export default RestaurantsSlice.reducer;
